// //////////////////
// Data Model
// //////////////////

export interface RecentlyEditedManuscript {
  novelId: string;
  novelTitle: string;
  manuscriptKey: string;
  manuscriptTitle: string;
  /** 編集日時（Unix timestamp, ミリ秒） */
  editedAt: number;
}

// //////////////////
// Request Model
// //////////////////

export interface RecentlyEditedManuscriptsInput {
  limit: number;
}
